import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import _get from 'lodash/get';

import { checkInternalUser } from '../actions/AuthedActions';
import m2DeskImage from '../assets/images/mtodesk.png';

const tmplMobileViewNotSupported = (
    <div style={{ width: '100%', height: '100%', margin: '150px auto' }}>
        <div className="align-center">
            <img src={m2DeskImage} alt="View in Desktop" style={{ display: 'unset' }} />
        </div>
        <h2 className="align-center" style={{ paddingTop: 10 }}>
            Please view in Desktop
        </h2>
        <p className="align-center">We don&#39;t support Mobile mode yet. Please go back to desktop mode for the best experience.</p>
    </div>
);

const RouteInterceptor = ({ ...props }) => {
    const { mobileSupported = false, isMobile = false } = props || {};
    if (isMobile && !mobileSupported) {
        return tmplMobileViewNotSupported;
    }
    if (_get(props, 'checkInternalUser') && !checkInternalUser()) {
        return <Redirect to="/" />;
    }
    return <Route {...props} />;
};

const mapStateToProps = (state: any) => {
    const {
        environment: { isMobile },
    } = state;
    return {
        isMobile,
    };
};

export default connect(mapStateToProps, {})(RouteInterceptor);
